import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "grid place-items-center mb-6 px-4 sm:px-0" }
const _hoisted_2 = {
  key: 0,
  class: "text-lg font-bold bg-blue-100 p-4 rounded-md shadow-lg inline-block mb-4"
}
const _hoisted_3 = { class: "relative w-full p-8 border border-gray-100 shadow-xl rounded-xl" }
const _hoisted_4 = { class: "absolute left-4 top-4 rounded-full px-3 py-1.5 bg-green-100 text-green-600 font-medium text-xs" }
const _hoisted_5 = { class: "absolute right-4 top-4 rounded-full px-3 py-1.5 bg-green-100 text-green-600 font-medium text-xs" }
const _hoisted_6 = { class: "mt-4 text-gray-500" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_8 = { class: "mt-4 text-xl font-bold text-gray-900" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "text-lg" }
const _hoisted_11 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-8"
}
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = ["name", "id"]
const _hoisted_14 = ["for"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, " Vote Yes ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "block mt-1 text-xs text-gray-500" }, " Yay ", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute w-5 h-5 text-blue-600 opacity-0 top-4 right-4 peer-checked:opacity-100",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = ["name", "id"]
const _hoisted_21 = ["for"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, " Vote No ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "block mt-1 text-xs text-gray-500" }, " Nay ", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute w-5 h-5 text-blue-600 opacity-0 top-4 right-4 peer-checked:opacity-100",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 3,
  class: "text-lg font-bold"
}

import { PropType, ref, computed } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useVoteStore } from "@/stores/votes";
import VoteStats from "@/components/ballot/VoteStats.vue";
import { sanitizeHtml } from "@/utils/sanitize";

export default /*#__PURE__*/_defineComponent({
  props: {
  vote: {
    type: Object as PropType<Vote>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const auth = useAuthStore();
const voteStore = useVoteStore();


const ballot = ref("");
const error = ref("");
const working = ref(false);

const home = computed(() => auth.house_details);

const did_i_vote = computed(() =>
  voteStore.did_i_vote(auth.user_id, props.vote.id)
);

const date = computed(() =>
  new Date(props.vote.response_deadline).toUTCString()
);

const cast_ballot = async () => {
  working.value = true;
  const ballot_obj = {
    user: auth.user_id,
    house: auth.house.id,
    vote: props.vote.id,
    response: ballot.value,
  };
  console.log(`Vote ${ballot.value}`);
  console.log(ballot_obj);
  error.value = "";
  try {
    const result = await voteStore.cast_ballot(ballot_obj);
    console.log(result);
    await voteStore.get_votes();
    working.value = false;
  } catch (e) {
    console.log(e);
    error.value =
      "There was an error casting your ballot please try again later";
    working.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(did_i_vote).length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " You voted: " + _toDisplayString(_unref(did_i_vote)[0].response) + " on behalf of " + _toDisplayString(_unref(home)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, " Voting Ends: " + _toDisplayString(_unref(date)), 1),
      _createElementVNode("span", _hoisted_5, " Response Required " + _toDisplayString(__props.vote.required_response) + " % ", 1),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("h5", _hoisted_8, _toDisplayString(__props.vote.title), 1),
        _createElementVNode("p", {
          class: "flex mt-2 mb-2 text-gray-900 justify-start w-full pre-wrap",
          innerHTML: _unref(sanitizeHtml)(__props.vote.description)
        }, null, 8, _hoisted_9),
        _createElementVNode("span", _hoisted_10, "You are voting for " + _toDisplayString(_unref(home)), 1),
        (_unref(did_i_vote).length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  class: "hidden group peer",
                  type: "radio",
                  name: `votingOption${__props.vote.id}`,
                  value: "yay",
                  id: `vote_yay_${__props.vote.id}`,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ballot).value = $event))
                }, null, 8, _hoisted_13), [
                  [_vModelRadio, ballot.value]
                ]),
                _createElementVNode("label", {
                  class: "block p-4 text-lg font-medium transition-colors border border-gray-100 rounded-lg shadow-sm cursor-pointer peer-checked:border-blue-500 hover:bg-gray-50 peer-checked:ring-1 peer-checked:ring-blue-500",
                  for: `vote_yay_${__props.vote.id}`
                }, _hoisted_17, 8, _hoisted_14),
                _hoisted_18
              ]),
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  class: "hidden group peer",
                  type: "radio",
                  name: `votingOption${__props.vote.id}`,
                  value: "nay",
                  id: `vote_nay_${__props.vote.id}`,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ballot).value = $event))
                }, null, 8, _hoisted_20), [
                  [_vModelRadio, ballot.value]
                ]),
                _createElementVNode("label", {
                  class: "block p-4 text-lg font-medium transition-colors border border-gray-100 rounded-lg shadow-sm cursor-pointer peer-checked:border-blue-500 hover:bg-gray-50 peer-checked:ring-1 peer-checked:ring-blue-500",
                  for: `vote_nay_${__props.vote.id}`
                }, _hoisted_24, 8, _hoisted_21),
                _hoisted_25
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(VoteStats, { vote: __props.vote }, null, 8, ["vote"])
            ])),
        (_unref(did_i_vote).length === 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              disabled: ballot.value === '',
              class: "bg-blue-500 disabled:bg-blue-100 disabled:text-gray-500 px-3 py-2 mt-2 text-xl w-full rounded-md font-bold text-white",
              onClick: cast_ballot
            }, [
              (working.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Submiting Vote..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_29, "Cast Ballot"))
            ], 8, _hoisted_27))
          : (_openBlock(), _createElementBlock("span", _hoisted_30, "You voted: " + _toDisplayString(_unref(did_i_vote)[0].response) + " on behalf of " + _toDisplayString(_unref(home)), 1))
      ])
    ])
  ]))
}
}

})